import styled from 'shared/utils/styled';

import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

export const Title = styled(Typography)(({ theme }) => ({
  marginTop: 0,
  fontFamily: 'NeoSansStd',
  fontSize: theme.typography.pxToRem(20),
  fontWeight: 700,
  color: 'rgb(34, 64, 96)',
  [theme.breakpoints.down(768)]: {
    fontSize: 18,
  },
}));

export const Loader = styled(CircularProgress)(() => ({
  color: 'rgb(34, 64, 96)',
}));
